function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".Delete-1{fill:#8e384e;}.Delete-2{fill:none;stroke:#8e384e;stroke-miterlimit:10;stroke-width:55px;}"));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "Delete-1",
  d: "M454.32,182.79,352.5,284.62,250.68,182.79a32,32,0,0,0-45.26,0l-22.63,22.63a32,32,0,0,0,0,45.26L284.62,352.5,182.79,454.32a32,32,0,0,0,0,45.26l22.63,22.63a32,32,0,0,0,45.26,0L352.5,420.38,454.32,522.21a32,32,0,0,0,45.26,0l22.63-22.63a32,32,0,0,0,0-45.26L420.38,352.5,522.21,250.68a32,32,0,0,0,0-45.26l-22.63-22.63A32,32,0,0,0,454.32,182.79Z",
  transform: "translate(-3.75 -3.75)"
});

var _ref4 = /*#__PURE__*/React.createElement("circle", {
  className: "Delete-2",
  cx: 348.75,
  cy: 348.75,
  r: 321.25
});

var SvgDelete = function SvgDelete(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Delete",
    viewBox: "0 0 697.5 697.5",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDelete, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Delete.7666fd80.svg";
export { ForwardRef as ReactComponent };